export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtVyrobeknd';
export const NAME = 'VyrobekNd';
